import { render, staticRenderFns } from "./contentCardBaseA.vue?vue&type=template&id=5a59d7dc&scoped=true"
import script from "./contentCardBaseA.vue?vue&type=script&lang=js"
export * from "./contentCardBaseA.vue?vue&type=script&lang=js"
import style0 from "./contentCardBaseA.vue?vue&type=style&index=0&id=5a59d7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a59d7dc",
  null
  
)

export default component.exports